import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@st-operations/uikit/src/v2'

import './styles.scss'

const Table = ({ header, items, renderAction, onSort, gridTemplateColumns, highlightOnHover }) => {
  const [hoveredRow, setHoveredRow] = useState(null)

  const cellClassName = (rowIndex, isActions) => {
    const classes = ['apa-table__cell']
    if (isActions) classes.push('apa-table__cell--actions')
    if (highlightOnHover && hoveredRow === rowIndex) classes.push('apa-table__cell--hovered')
    return classes.join(' ')
  }

  const rowHoverProps = (rowIndex) =>
    highlightOnHover
      ? {
          onMouseEnter: () => setHoveredRow(rowIndex),
          onMouseLeave: () => setHoveredRow((current) => (current === rowIndex ? null : current)),
        }
      : {}

  return (
    <div className="apa-table" style={{ '--grid-template-columns': gridTemplateColumns }}>
      {/* header */}
      <For each="column" of={header}>
        <div key={column} className=" apa-table__cell apa-table__cell--header">
          <span>{column}</span>
          <If condition={onSort}>
            <button onClick={() => onSort(column)}>
              <Icon icon="sort" type="outline" height={14} width={14} />
            </button>
          </If>
        </div>
      </For>
      <If condition={renderAction}>
        <div className="apa-table__cell apa-table__cell--header apa-table__cell--actions">
          <span>Actions</span>
        </div>
      </If>
      {/* body */}
      <For each="row" index="rowIndex" of={items}>
        <For each="cell" index="cellIndex" of={row.values}>
          <div
            key={`${rowIndex}-${cellIndex}`}
            className={cellClassName(rowIndex, false)}
            {...rowHoverProps(rowIndex)}
          >
            {cell}
          </div>
        </For>
        <If condition={renderAction}>
          <div className={cellClassName(rowIndex, true)} {...rowHoverProps(rowIndex)}>
            {renderAction(row.data)}
          </div>
        </If>
      </For>
    </div>
  )
}

Table.propTypes = {
  header: PropTypes.arrayOf(PropTypes.string).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.object.isRequired,
      values: PropTypes.arrayOf(PropTypes.node).isRequired,
    })
  ).isRequired,
  renderAction: PropTypes.func,
  gridTemplateColumns: PropTypes.string.isRequired,
  onSort: PropTypes.func,
  highlightOnHover: PropTypes.bool,
}

Table.defaultProps = {
  highlightOnHover: false,
}

export default Table
